module.exports = __webpack_public_path__ + "img/sidebar-narrow-lms-icon.080afc3c.png";